import React from 'react';
import { useLoaderData } from 'react-router-dom';
import SIngleNewsCard from './SIngleNewsCard';

const AllNews = () => {
  const newses = useLoaderData();
  // console.log(newses);
  return (
    <div className='col-span-2'>
      {
        newses.map(news => <SIngleNewsCard
          key={news._id}
          news = {news}
        ></SIngleNewsCard>)
      }
    </div>
  );
};

export default AllNews;